
import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react'
import { LocalStorageProvider } from './Context/LocalStorageContext';


function App() {


  useEffect(() => {
    localStorage.removeItem('ciudad');
  }, []);

  return (

    <LocalStorageProvider>
      <RouterProvider router={router} />
    </LocalStorageProvider>

  );
}

export default App;
